import { render } from "./disalcode-flag.vue?vue&type=template&id=185df33d&ts=true"
import script from "./disalcode-flag.vue?vue&type=script&lang=ts"
export * from "./disalcode-flag.vue?vue&type=script&lang=ts"

import exportComponent from "/geosite/web/geosite-de/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__